export const TECHNICAL_ERROR_MESSAGE = "Due to technical issue , We cannot process your request now. Please try after some time.";
export const TECHNICAL_OTP_ERROR_MESSAGE = "Due to technical issue, OTP Not Sent.";